import { render, staticRenderFns } from "./compensation.vue?vue&type=template&id=4b059506&scoped=true&"
import script from "./compensation.vue?vue&type=script&lang=js&"
export * from "./compensation.vue?vue&type=script&lang=js&"
import style0 from "./compensation.vue?vue&type=style&index=0&id=4b059506&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b059506",
  null
  
)

export default component.exports